import { ResponseTypes } from "../../services/APIEarlyWarningService";

const BASE_URL = process.env.REACT_APP_BASE_URL

const getToken = (): string => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }
    return token
}

export type APIRequestGetRecipientBody = {
    warningId: string;
    workflowId: string;
}

export type APIResponseGetRecipient = {
    email: string;
    firstName: string;
    department: string;
    departmentName: string;
    role: string;
    username: string;
    organization: string;
    organizationName: string;
}

export const APIGetRecipients = async (body: APIRequestGetRecipientBody): Promise<{status: boolean, data: APIResponseGetRecipient[], message: string}> => {

    const URL: string = `${BASE_URL}/ew/api/v1/getUserRecipients`
    const HEADER: RequestInit = {
        method: "POST",
        headers: {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body)
    }

    try
    {
        const response = await fetch(URL, HEADER)
        const responseJson = await response.json()

        if (response.ok)
        {
            const responseData: ResponseTypes = responseJson as ResponseTypes
            //console.log("RESPONSE -> ", responseData)
            return {status: true, data: responseData.data, message: "users' data found"}
        }
        else 
        {
            return {status: false, data: [], message: "failed to get users"}
        }
    }
    catch (error)
    {
        console.error("failed to retrieve user data with error [", error, "]")
        return {status: false, data: [], message: "failed to get users"}
    }
}

export const APIGetRecipientsExternal = async (body: APIRequestGetRecipientBody, token: string): Promise<{status: boolean, data: APIResponseGetRecipient[], message: string}> => {

    const URL: string = `${BASE_URL}/jwt-auth/api/v1/getUserRecipients?token=${token}`
    const HEADER: RequestInit = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body)
    }

    try
    {
        const response = await fetch(URL, HEADER)
        const responseJson = await response.json()

        if (response.ok)
        {
            const responseData: ResponseTypes = responseJson as ResponseTypes
            //console.log("RESPONSE -> ", responseData)
            return {status: true, data: responseData.data, message: "users' data found"}
        }
        else 
        {
            return {status: false, data: [], message: "failed to get users"}
        }
    }
    catch (error)
    {
        console.error("failed to retrieve user data with error [", error, "]")
        return {status: false, data: [], message: "failed to get users"}
    }
}